/* Chelsea and Rachel Co. 2024 */


class CnR {

  api_version = "2024-07";
  keyname = "subscriptions-2024-02";
  constructor(opts = {}) {
    this.config = { ...this.defaults(), ...opts };
    this.errors = [];
    this.requires().forEach(field => {
      if (!field in this.config) {
        this.errors.push(`Missing Required config field: ${field}`)
      }
    });
    if (this.errors.length > 0) {
      throw new Error(this.errors.join("\n"));
    }

  }
  requires() {
    return []
  }
  defaults() {
    return {
      api_version: "2023-07",
      keyname: "subscriptions-2024-02"
    };
  }
  fetch(url, config) {
    if (this.config.fetch_function) {
      return pure_fetch(url, config)
    } else {
      return fetch(url, config)
    }
  }
  /* shopify cart functions */
  async getCart(url = "/cart.js", extended = false, callback = () => { }) {
    let cart = {};
    return this.fetch(url)
      .then(res => (extended) ? res.text() : res.json());
  }
  async request(url) {
    return this.fetch(url).then(text => response.text())
  }
  async updateCart(payload) {
    return this.fetch(`/cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(payload)
    }).then((response) => response.json());
  }
  async removeItemFromCart(key) {
    return this.changeCart({
      id: key,
      quantity: 0
    })
  }
  async updateItemCount(key, quantity) {
    return this.changeCart({
      id: key,
      quantity: parseInt(quantity)
    })
  }
  async changeCart(payload) {
    return this.fetch(`/cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(payload)
    }).then((response) => response.json());
  }
  async addToCart(payload) {
    let config = {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }
    return this.fetch("/cart/add.js", config)
      .then((response) => response.json())
  }

  static setupDawnProductForm(form) {
    form.querySelector("button").addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      new CnR().addToDawnCart(form).then(response => {

      });
    });
  }
  async addToDawnCart(form) {

    let cart = document.querySelector("cart-drawer");
    const formData = new FormData();
    formData.append('product-id', form.dataset.productId);
    formData.append("id", form.querySelector('[name="id"]').value)
    formData.append("quantity", 1);
    try {
      formData.append("selling_plan", form.querySelector('[name="selling_plan"]').value);
    } catch (e) { }

    formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', form.dataset.url);
    formData.append('form_type', 'product');

    return this.fetch("/cart/add", {
      method: 'POST',
      headers: {
        "Accept": "application/javascript",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: formData, form
    })
      .then((response) => response.json())
      .then(json => {


        if (json.status) {
          CnRModal.show(json.description);
        } else {
          cart.renderContents(json);
          cart.classList.remove("is-empty")
        }
        return json;
      });
  }

  /* graphql functions */
  async graphql(query, params) {
    return fetch(`/api/${this.api_version}/graphql.json`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "X-Shopify-Storefront-Access-Token": this.config.graphql_token
      },
      body: JSON.stringify({ query: query, variables: params })
    })
      .then(response => response.json())
  }
  graphql_sync(query, params) {
    let ajax = new XMLHttpRequest();
    ajax.headers = {
      "content-type": "application/json",
      "X-Shopify-Storefront-Access-Token": this.config.graphql_token
    }
    ajax.open("POST", /api/`${this.api_version}/graphql.json`, false)
    ajax.setRequestHeader("Content-Type", "application/json");
    ajax.setRequestHeader("X-Shopify-Storefront-Access-Token", storefront_token);
    ajax.send(JSON.stringify({ query: query, params: params }));
    return JSON.parse(ajax.responseText);
  }
  gid2id(gid) {
    return parseInt(gid.split("/").pop())
  }
  collapse_query(object) {
    if (object == null) {
      return object;
    }
    switch (object.constructor.name) {
      case "Array":
        return object.map(item => this.collapse_query(item));
        break;
      case "Object":
        let ret = {};
        Object.keys(object).forEach(key => {
          if (object[key] == null) {
            ret[key] = null;
            return;
          }
          if (object[key].reference) {
            ret[key] = this.collapse_query(object[key].reference)
            return;

          }
          if (object[key].references) {
            let all = [];
            object[key].references.nodes.forEach(ref => {
              let crv = {};
              ref.fields.forEach(field => {
                crv[field.key] = this.collapse_query(field.value)
              })
              all.push(crv)
            })
            object[key] = all;

          }
          if (object[key].nodes && object[key].nodes.constructor.name == "Array") {
            ret[key] = this.collapse_query(object[key].nodes);
          } else {
            ret[key] = this.collapse_query(object[key])
          }
        });
        return ret
        break;
      default:
        if (object) {
          return object;
        }

        break;
    }
  }
  css() {
    return '';
  }
  inject_css() {
    let css = this.css();
    if (css.length > 0) {
      let style = document.createElement("style");
      style.id = this.constructor.name.toLowerCase();
      style.textContent = this.css();
      document.querySelector("head").appendChild(style);
    }

  }
}
class CnrStorefront extends CnR {
  requires() {
    return ["graphql_token"]
  }
}
/* src/cnr-gift-note-cart/CnRGiftNote.js  */
//* Copyright 2023 Chelsea and Rachel Co. ellie@chelseaandrachel.com *//


class CnRGiftNote extends CnR {
  defaults() {
    return {
      context: "sidecart",
      target: ".cnr-giftnote-holder",
      button_text_empty: "Add Note",
      button_text_set: "Update",
      button_text_updating: "Updating Note...",
      checkbox_label_text: "Add A Note",
      extended_cart: false,
    };
  }
  constructor(opts = {}) {
    super(opts)
    document.addEventListener("CartUpdated", (event) => {
      this.cart = event.detail;
      this.render();
    });
  }

  hasGift() {
    return this.cart.attributes['gift'] != null;
  }
  giftText() {
    return this.cart.attributes["Gift Note"] || "";
  }
  render() {
    let injection_point = document.querySelector(this.config.target);
    if (!injection_point) {
      console.error(`Injection target ${this.config.target} does not exist`);
    }
    injection_point.childNodes.forEach(node => injection_point.removeChild(node));

    let html = "";
    if (this.hasGift()) {
      html += `
			<div>
				<div class="d-flex justify-content-between">
				<h3 class="cnr-gift-note-has-note">${this.config.cart_gift_message_added_label}</h3>
				<a class="cnr-gift-note-cart-open-form">Edit / Remove</a>
				</div>
				<p>${this.config.cart_gift_message_notice}</p>
				<p class="cnr-gift-note-cart-message"><i>“<span message="">${this.giftText()}</span>...”</i></p>
			</div>
			`
    } else {
      html += `
			<div class="cnr-gift-note-cart-add-message cnr-gift-note-cart-open-form" btn-open>
				${this.config.cart_gift_message_label}
			</div>
			`
    }
    html += this.noteForm();
    injection_point.innerHTML = `<div class='cnr-gift-note-cart-message ${this.hasGift() ? 'has-message' : ''}'>${html}</div>`;

    injection_point.querySelectorAll(".cnr-gift-note-cart-open-form").forEach(button => button.addEventListener("click", button => {
      document.querySelector(".cnr-gift-note-cart-message").classList.add("active");
    }));
    injection_point.querySelectorAll(".cnr-gift-note-cart-cancel").forEach(button => button.addEventListener("click", button => {
      document.querySelector(".cnr-gift-note-cart-message").classList.remove("active");
    }));
    //btn-clear

    injection_point.querySelector("textarea").addEventListener("keypress", event => {
      let remaining = this.config.cart_gift_message_max - injection_point.querySelector("textarea").value.length;
      if (remaining <= 0) {
        event.stopImmediatePropagation();
        return false;
      }
      document.querySelector(".cnr-gift-note-cart-char-count").innerHTML = remaining;
    });
    injection_point.querySelector(".cnr-gift-note-cart-save").addEventListener("click", event => {
      this.handleUpdate();

    });
    injection_point.querySelector(".cnr-gift-note-cart-clear").addEventListener("click", event => {
      this.clear();
      document.querySelector(".cnr-gift-note-cart--message").classList.remove("active");
    });
  }
  noteForm() {
    return `
		<div class="cnr-gift-note-cart-form">
			<h3 class="h1">${this.config.cart_gift_message_popup_label}</h3>

			<textarea class="cnr-gift-note-cart-text" name="note" maxlength="${this.config.cart_gift_message_max}">${this.giftText()}</textarea>
			<div class="cnr-gift-note-cart-utility">
				<small><span count="" class="cnr-gift-note-cart-char-count">${this.config.cart_gift_message_max - this.giftText().length}</span> Characters remaining</small>
				<small><a class="cnr-gift-note-cart-clear">Clear</a></small>
			</div>
			<div class="cnr-gift-note-cart-form-footer">
			<button type="button" class="btn btn-primary cnr-gift-note-cart-save">Save Message</button>
			<a class="cnr-gift-note-cart-cancel">Cancel</a>
			</div>
		</div>
		`;
  }
  handleUpdate() {
    this.cart.note = injection_point.querySelector("textarea").value;
    this.updateCart({ note: injection_point.querySelector("textarea").value })
      .then(json => this.render());
    document.querySelector(".cnr-gift-note-cart-message").classList.remove("active");
  }
}
/* li-lac.js  */
class LiLacCartNote extends CnRGiftNote {
  constructor(options) {
    super(options)
    document.addEventListener('rebuy:smartcart.show', (event) => {
      this.cart = event.detail.smartcart.cart;
      if (this.newNote != null) {
        this.cart.note = this.newNote;
        this.newNote = null;
      }
      this.render();
    });
    document.addEventListener("cnr:note:updated", event => {
      this.newNote = event.detail;

      document.setTimeout(
        () => {
          let noteField = document.querySelector(".cnr-gift-note-cart-text.cart-note-field")
          if (noteField) {
            noteField.value = event.detail;
          }
        },
        500
      )
    })

  }
  hasGift() {

    return this.cart.note != null && this.cart.note != "";
  }
  giftText() {
    return this.cart.note || "";
  }
  shipDate() {
    if (this.cart.attributes['Delivery-Date']) {
      let date = this.cart.attributes['Delivery-Date'].split("/")
      return [date[2], date[0], date[1]].join("-");
    } else {
      return '';
    }
  }
  shipDateDisplay() {
    if (this.cart.attributes['Delivery-Date']) {
      const SHORT_MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      let date = this.cart.attributes['Delivery-Date'].split("/");
      return `${parseInt(date[1])} ${SHORT_MONTHS[parseInt(date[0])-1]} ${date[2]}`;
    } else {
      return ' ';
    }
  }

  hasDate() {

    return this.cart.attributes['Delivery-Date'] && this.cart.attributes['Delivery-Date'] != "";
  }
  daysHence(days) {
    Date.prototype.addDays = function (num) {
      var value = this.valueOf();
      value += 86400000 * num;
      return new Date(value);
    }

    let d = new Date().addDays(days);
    return d.toISOString().substring(0, 10);


  }
  noteForm() {
    return `
    <div class="padding">
       <button class="cart-expand-header gift-message" id="giftMessage" aria-controls="messageBox" 	aria-expanded="false">
          <label for="messageBox" class="order-summary-title">Add A Gift Note</label>
          <span class="open-close" aria-hidden="true">
             <div class="more">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                  <path d="M8.75 12.5L15 18.75L21.25 12.5" stroke="#331B00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
             </div>
          </span>
       </button>
       <div class="cart-expand-content" aria-labelledby="giftMessage" id="messageBox" role="region">
          <div class="field">
            <textarea
              id="rebuy-cart-note-field"
              class="cnr-gift-note-cart-text cart-note-field text-area field__input"
              name="note"
              maxlength="${this.config.cart_gift_message_max}"
              rows="3"
              placeholder=" "
            >${this.giftText()}</textarea>
            <label class="form__label field__label" for="rebuy-cart-note-field">${this.config.cart_gift_message_max - this.giftText().length} characters remaining</label>
          </div>
       </div>
    </div>
      <div class="padding buy-now-ship-later">
         <button class="cart-expand-header" id="SendLater" aria-controls="datePicker" aria-expanded="false">
            <label for="CartNote" class="order-summary-title buy-now-ship-later-label">
              Buy Now Ship Later
              <span class="cnr-tooltip-wrap" data-tooltip="Orders normally ship within 1-2 business days unless a future ship date is selected.">
                <svg width="16" height="16" viewBox="0 0 0.48 0.48" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="rgba(51, 27, 0, 0.90)" stroke-width=".04" d="M.44.24a.2.2 0 0 1-.2.2.2.2 0 0 1-.2-.2.2.2 0 0 1 .4 0z"/><path d="M.24.14h0" stroke="rgba(51, 27, 0, 0.90)" stroke-width=".04" stroke-linecap="round"/><path d="M.2.22h.04v.1M.2.32h.08" stroke="rgba(51, 27, 0, 0.90)" stroke-width=".04" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </span>
            </label>
            <div class="datePicker-date-display-wrapper">
              <div class="datePicker-date-display">${this.hasDate() ? this.shipDateDisplay() : ''}</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <path d="M8 13.4446V21.2223C8 21.4286 8.08194 21.6264 8.22781 21.7723C8.37367 21.9182 8.5715 22.0001 8.77778 22.0001H21.2222C21.4285 22.0001 21.6263 21.9182 21.7722 21.7723C21.9181 21.6264 22 21.4286 22 21.2223V13.4446M8 13.4446H22M8 13.4446V10.3334C8 10.1272 8.08194 9.92933 8.22781 9.78347C8.37367 9.63761 8.5715 9.55566 8.77778 9.55566H21.2222C21.4285 9.55566 21.6263 9.63761 21.7722 9.78347C21.9181 9.92933 22 10.1272 22 10.3334V13.4446" stroke="#331B00" stroke-width="1.61539" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17.6914 8V11.2308" stroke="#542497" stroke-width="1.61539" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.3086 8V11.2308" stroke="#542497" stroke-width="1.61539" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            </button>    
         <div class="cart-expand-content date-picker" role="region" id="datePicker" aria-labelledby="SendLater">         
            <div class="buy-now-ship-later">BUY NOW, SHIP LATER. Select a future ship date below:</div>
            <div class="cnr-custom-cal-wrap">
              <div class="cnr-custom-calendar">
                <div class="cnr-cal-header">
                  <button class="cnr-cal-nav cnr-cal-prev" type="button" aria-label="Previous month">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M10.1831 4.175L6.35811 8L10.1831 11.825L8.99977 13L3.99977 8L8.99977 3L10.1831 4.175Z" fill="#121212"/>
                    </svg>
                  </button>
                  <span class="cnr-cal-month-year"></span>
                  <button class="cnr-cal-nav cnr-cal-next" type="button" aria-label="Next month">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M5 11.825L8.825 8L5 4.175L6.18333 3L11.1833 8L6.18333 13L5 11.825Z" fill="#121212"/>
                    </svg>
                  </button>
                </div>
                <div class="cnr-cal-weekdays">
                  <span>SUN</span><span>MON</span><span>TUE</span><span>WED</span><span>THU</span><span>FRI</span><span>SAT</span>
                </div>
                <div class="cnr-cal-days"></div>
                <div class="cnr-cal-footer">
                  <button class="cnr-cal-clear" type="button">Clear</button>
                  <button class="cnr-cal-today" type="button">Today</button>
                </div>
              </div>
              <input id="cnr-gift-ship-date" type="hidden" name="date" value="${this.shipDate()}">
            </div>
         </div>`;
  }
  changed() {
    if (this.intervalID) {
      window.clearTimeout(this.intervalID);
    }
    this.interval = window.setTimeout(() => {
      window.clearTimeout(this.intervalID);
      this.handleUpdate()
      this.intervalID = null;
    }, 400);
  }
  dateChanged() {
    this.handleUpdate();
  }
  render() {

    let injection_point = document.querySelector(this.config.target);
    injection_point.innerHTML = this.noteForm()
    const _tooltipWrap = injection_point.querySelector('.cnr-tooltip-wrap');
    if (_tooltipWrap) {
      _tooltipWrap.addEventListener('click', e => e.stopPropagation());
    }
    injection_point.querySelector("textarea").addEventListener("input", event => {
        let remaining = Math.max(0, this.config.cart_gift_message_max - injection_point.querySelector("textarea").value.length);
        const _label = injection_point.querySelector('label[for="rebuy-cart-note-field"]');
        if (_label) _label.textContent = remaining + ' characters remaining';
    });
    injection_point.querySelector("textarea").addEventListener("blur", () => {
      this.handleUpdate();
    });
    // ── Custom Calendar ──────────────────────────────────────────
    const _calWrap = injection_point.querySelector('.cnr-custom-cal-wrap');
    if (_calWrap) {
      const _minDateStr = this.daysHence(0);
      const _minDate = new Date(_minDateStr + 'T00:00:00');
      const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      let _calState = { year: null, month: null, selectedDate: injection_point.querySelector('#cnr-gift-ship-date').value || null };
      const _initView = _calState.selectedDate ? new Date(_calState.selectedDate + 'T00:00:00') : new Date();
      _calState.year = _initView.getFullYear();
      _calState.month = _initView.getMonth();

      const _renderCal = () => {
        const daysEl = _calWrap.querySelector('.cnr-cal-days');
        const myEl = _calWrap.querySelector('.cnr-cal-month-year');
        if (!daysEl || !myEl) return;
        myEl.textContent = MONTH_NAMES[_calState.month] + ' ' + _calState.year;
        const firstDay = new Date(_calState.year, _calState.month, 1).getDay();
        const daysInMonth = new Date(_calState.year, _calState.month + 1, 0).getDate();
        let html = '';
        for (let i = 0; i < firstDay; i++) html += '<span class="cnr-cal-day empty"></span>';
        for (let d = 1; d <= daysInMonth; d++) {
          const ds = _calState.year + '-' + String(_calState.month + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
          const isPast = new Date(ds + 'T00:00:00') < _minDate;
          const isSel = ds === _calState.selectedDate;
          html += '<button type="button" class="cnr-cal-day' + (isPast ? ' disabled' : '') + (isSel ? ' selected' : '') + '" data-date="' + ds + '"' + (isPast ? ' disabled' : '') + '>' + d + '</button>';
        }
        daysEl.innerHTML = html;
      };

      _renderCal();

      _calWrap.querySelector('.cnr-cal-prev').addEventListener('click', () => {
        _calState.month--; if (_calState.month < 0) { _calState.month = 11; _calState.year--; } _renderCal();
      });
      _calWrap.querySelector('.cnr-cal-next').addEventListener('click', () => {
        _calState.month++; if (_calState.month > 11) { _calState.month = 0; _calState.year++; } _renderCal();
      });
      _calWrap.querySelector('.cnr-cal-days').addEventListener('click', (e) => {
        const btn = e.target.closest('.cnr-cal-day:not(.disabled)');
        if (!btn || btn.classList.contains('empty')) return;
        _calState.selectedDate = btn.dataset.date;
        injection_point.querySelector('#cnr-gift-ship-date').value = _calState.selectedDate;
        _renderCal();
        this.handleUpdate();
        const [_y, _m, _d] = _calState.selectedDate.split('-');
        injection_point.querySelector('.datePicker-date-display').textContent = `${parseInt(_d)} ${MONTH_NAMES[parseInt(_m)-1].slice(0,3)} ${_y}`;
        $(injection_point.querySelector('#datePicker')).slideUp(200);
        injection_point.querySelector('#SendLater').classList.remove('expanded');
        injection_point.querySelector('#SendLater').setAttribute('aria-expanded', 'false');
      });
      _calWrap.querySelector('.cnr-cal-clear').addEventListener('click', () => {
        _calState.selectedDate = null;
        injection_point.querySelector('#cnr-gift-ship-date').value = '';
        _renderCal();
        this.clear();
        injection_point.querySelector('.datePicker-date-display').textContent = '';
        $(injection_point.querySelector('#datePicker')).slideUp(200);
        injection_point.querySelector('#SendLater').classList.remove('expanded');
        injection_point.querySelector('#SendLater').setAttribute('aria-expanded', 'false');
      });
      _calWrap.querySelector('.cnr-cal-today').addEventListener('click', () => {
        const td = new Date(); const use = td < _minDate ? _minDate : td;
        const ds = use.getFullYear() + '-' + String(use.getMonth() + 1).padStart(2, '0') + '-' + String(use.getDate()).padStart(2, '0');
        _calState.year = use.getFullYear(); _calState.month = use.getMonth(); _calState.selectedDate = ds;
        injection_point.querySelector('#cnr-gift-ship-date').value = ds;
        _renderCal();
        this.handleUpdate();
        const [_y, _m, _d] = ds.split('-');
        injection_point.querySelector('.datePicker-date-display').textContent = `${parseInt(_d)} ${MONTH_NAMES[parseInt(_m)-1].slice(0,3)} ${_y}`;
      });
    }
    // ────────────────────────────────────────────────────────────
    // Click outside to close date picker
    if (this._datePickerAbortController) this._datePickerAbortController.abort();
    this._datePickerAbortController = new AbortController();
    const _datePickerSection = injection_point.querySelector('.buy-now-ship-later');
    if (_datePickerSection) {
      document.addEventListener('click', (e) => {
        if (!_datePickerSection.contains(e.target)) {
          const _dp = injection_point.querySelector('#datePicker');
          const _sl = injection_point.querySelector('#SendLater');
          if (_dp && _sl && _sl.classList.contains('expanded')) {
            $(_dp).slideUp(200);
            _sl.classList.remove('expanded');
            _sl.setAttribute('aria-expanded', 'false');
          }
        }
      }, { signal: this._datePickerAbortController.signal });
    }
    injection_point.querySelectorAll(".cart-expand-content").forEach(item => $(item).slideUp(200));
    injection_point.querySelectorAll(".cart-expand-header").forEach(item => item.addEventListener("click", event => {
      injection_point.querySelectorAll(".cart-expand-header").forEach(item => item.setAttribute("aria-expanded", "false"))

      const target = item.id === 'SendLater'
        ? injection_point.querySelector('#datePicker')
        : item.nextElementSibling;
      $(target).slideToggle(200);
      $(item).toggleClass("expanded");
      if (item.classList.contains("expanded")) {
        item.setAttribute("aria-expanded", "true")
      } else {
        item.setAttribute("aria-expanded", "false")
      }
    }))
  }
  clear() {
    this.cart.attributes['Delivery-Date'] = null;
    this.cart.note = "";

    this.updateCart({ note: "", attributes: this.cart.attributes })
      .then(json => this.opret = json);

  }
  handleUpdate() {
    let injection_point = document.querySelector(this.config.target);
    this.cart.note = injection_point.querySelector("textarea").value;
    let date = injection_point.querySelector("#cnr-gift-ship-date").value.split("-");

    if (date.length == 3) {
      this.cart.attributes["Delivery-Date"] = [date[1], date[2], date[0]].join("/");
    }
    this.updateCart({ note: this.cart.note, attributes: this.cart.attributes })
      .then(json => this.opret = json);
  }
}
/* src/cnr-modal/cnr-modal.js  */
class CnRModal extends CnR {
  static show(content, closeable = true) {
    let modal = document.querySelector(".cnr-modal");
    if (!modal) {
      modal = document.createElement("DIV");
      modal.classList.add("cnr-modal");
      document.querySelector("body").appendChild(modal);
    }
    modal.style.width = `${window.innerWidth}px`;
    modal.style.height = `${window.innerHeight}px`;
    modal.style.top = `${window.scrollY}px`
    modal.innerHTML = `
            <div class="modal-content">
                <span class="close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" role="presentation"><path d="M5.86123 14.1073L5.21766 14.1073L3.67204 12.5617L3.67204 11.9181L6.68057 8.90959L3.6521 5.88112L3.6521 5.23755L5.2376 3.65205L5.88117 3.65204L8.90964 6.68052L11.9182 3.67199L12.5617 3.67199L14.1074 5.21761L14.1074 5.86118L11.0988 8.86971L14.1273 11.8982L14.1273 12.5417L12.5418 14.1273H11.8982L8.86976 11.0988L5.86123 14.1073Z" fill="#af3939"></path></svg>
                </span>
                <div class="modal-text text-left color-foreword-primary body1">
                    ${content}
                </div>
            </div>
            `;
    if (closeable) {
      modal.querySelector(".close").style.display = "block";
      modal.querySelector(".close").addEventListener("click", event => {
        modal.classList.remove("active");
        modal.innerHTML = "";
        document.querySelector("body").classList.remove("stop-scrolling");
        document.dispatchEvent(new CustomEvent("cnr:modal:closed", { bubbles: true }))
      });
      modal.addEventListener("click", event => {
        if (event.target.classList.contains("cnr-modal")) {
          modal.classList.remove("active");
          modal.style.top = "0px";
          modal.innerHTML = "";
          document.querySelector("body").classList.remove("stop-scrolling");
          document.dispatchEvent(new CustomEvent("cnr:modal:closed", { bubbles: true }))
        }
      })
    } else {
      modal.querySelector(".close").style.display = "none";
    }
    document.querySelector("body").classList.add("stop-scrolling");
    modal.classList.add("active");
    return modal;
  }
  static close() {
    let modal = document.querySelector(".cnr-modal");
    modal.classList.remove("active");
    modal.innerHTML = "";
    document.querySelector("body").classList.remove("stop-scrolling");
    return modal
  }
}
/* src/cnr-magic-atc/cnr-atc.js  */
class CnRAtc extends CnR {
  constructor(options) {
    super(options)
    this.setupEvents()
    this.selectedVariant = null
    this.sellingPlanId = null
    this.properties = {}
  }
  setupEvents() {

  }
  selectVariant(object) {
    this.selected = object;
    this.selectedVariant = object.dataset.variantId;

    this.sellingPlanId = object.dataset.sellingPlan;
    this.postSelect()
  }
  postSelect() { }
  atc() {
    let payload = {
      id: this.selectedVariant,
    }
    if (this.selllingPlanId != null) {
      payload.selling_plan = this.sellingPlanId
    }
    if (Object.keys(this.properties).length > 0) {
      payload.properties = this.properties;
    }

    this.addToCart(payload).then(cart => this.postAdd(cart))
  }
  postAdd(cart) { }
}
/* li-lac.js  */
class LiLacCOMClub extends CnRAtc {
  constructor(options) {
    super(options);
    this.getCart().then(cart => {
      this.note = cart.note || "";
    })



  }
  setupEvents() {
    document.querySelectorAll(".subscription-button").forEach(
      button => {

        button.addEventListener(
          "click", event => this.selectVariant(button)
        )
      }
    )
  }
  modalClosed() {
    this.atc()
  }
  postSelect() {

    if (!this.selectedVariant) {
      return;
    }
    if (this.selected.dataset.selectDate != "true") {
      this.atc()
      return;
    }
    let innerHTML = `
        <div class="com-add-note">
            <div class="hero-subtitle h3">${this.config.popup_title}</div>
            <div class="com-date-field${this.selected.dataset.selectDate == "true" ? ' enabled' : ''}">
              <div class="label">
                <label for="com-datefield">${this.selected.dataset.selectorLabel}</label>
              </div>
              <div class="com-date-input">
                <select name="birthday-month" class="birthday-month-field">
                  <option value="January">January</option>
                  <option value="February">February</option>
                  <option value="March">March</option>
                  <option value="April">April</option>
                  <option value="May">May</option>
                  <option value="June">June</option>
                  <option value="July">July</option>
                  <option value="August">August</option>
                  <option value="September">September</option>
                  <option value="October">October</option>
                  <option value="November">November</option>
                  <option value="December">December</option>
                </select>
              </div>
            </div>
            <div class="buttons">
            <button class="button button--primary caps com-note-cancel">Cancel</button>
            <button class="button button--primary caps com-note-nothanks" style="display:none">${this.config.decline_text}</button>
             <button class="button button--primary caps com-note-submit">Submit</button>
            </div>
        </div>
        `
    let modal = CnRModal.show(innerHTML, false);
    modal.querySelector(".modal-content").classList.add("note-modal-bg")

    let submit = modal.querySelector(".com-note-submit")
    let nothanks = modal.querySelector(".com-note-nothanks")


    modal.querySelector(".com-note-cancel").addEventListener("click", event => {
      CnRModal.close()
    })

    modal.querySelectorAll(".com-gift-message").forEach(message => {

      message.addEventListener("keyup", event => {
        let remaining = maxChars - message.value.length;
        if (remaining < 1) {
          submit.disabled = false;
          message.value = message.value.substring(0, maxChars)
          modal.querySelector(".cnr-gift-note-cart-char-count").textContent = 0;
          event.stopImmediatePropagation()
          return false;
        }
        modal.querySelector(".cnr-gift-note-cart-char-count").textContent = remaining;
      })
    })

    submit.addEventListener("click", event => {
      let monthField = modal.querySelector(".birthday-month-field")
      this.birthdayMonth = monthField.options[monthField.selectedIndex].value

      this.setProperties()

      CnRModal.close()
      this.atc()
    })
    nothanks.addEventListener("click", event => {
      this.birthdayMonth = null;
      this.setProperties()
      CnRModal.close()
      this.atc()
    })
  }
  setProperties() {
    if (this.birthdayMonth) {
      this.properties = {}
      this.properties[this.config.birthday_property_name] = this.birthdayMonth;
    }
  }
  postAdd(cart) {
    this.note = "";
    this.properties = {}
    document.dispatchEvent(new CustomEvent("cnr:note:updated", { bubbles: true, detail: this.note }))

  }
}

class LilacGiftingHandler extends CnR {
  constructor(options) {
    super(options)
    this.submitButton = document.querySelector(".gifting-submit")
    this.uploadCache = {}
    this.setupEvents()
    this.checkValues()
    this.uuid = sessionStorage.getItem("giftingUuid")
    if (this.uuid == null) {
      this.uuid = crypto.randomUUID()
      sessionStorage.setItem("giftingUuid", this.uuid)
    }

  }
  root() {
    return document.querySelector(this.config.optionsRoot)
  }
  buildProperties() {
    let items = {}
    this.propertiesComplete = true;
    let propertySelectors = this.root().querySelectorAll('.color-dropdown-options');
    propertySelectors.forEach(options => {

      let itemKey = options.dataset.collate;
      let selectedItem = null;
      if (options.tagName == "DIV") {
        selectedItem = options;
      } else {
        selectedItem = options.querySelector('[aria-selected="true"]');
      }

      if (!selectedItem) {
        this.propertiesComplete = false;
        return;
      }
      if (!items[itemKey]) {
        items[itemKey] = {
          title: null,
          optionValues: [],
        };
      }
      if (options.dataset.formTitle) {
        items[itemKey].title = options.dataset.formTitle;
      }
      items[itemKey].optionValues.push(selectedItem.dataset.value)
    })
    items = Array.from(Object.values(items))

    let visiblePropertyItemBuilder = (item) => {
      let newObject = {}
      newObject[item.title] = item.optionValues.join(" ")
      return newObject
    };

    let properties = items.reduce((a, b) => Object.assign(a, visiblePropertyItemBuilder(b)), {});
    let shippingOptionType = document.querySelector("input[data-shipping-type]:checked");

    properties._gifting = {
      items: items.map(item => Object.assign({}, { title: `${item.title.trim()}: ${item.optionValues.join(" ")}` })),
      shipping_type: shippingOptionType.dataset.shippingType,
    }
    Object.entries(this.uploadCache).forEach(kvp => properties._gifting[kvp[0]] = kvp[1])
    console.error(properties)
    return properties

  }
  checkValues() {
    let properties = this.buildProperties();

    if (this.propertiesComplete) {
      this.submitButton.disabled = false;
      this.submitButton.classList.remove("inactive")
    } else {
      this.submitButton.disabled = true;
      this.submitButton.classList.add("inactive")
    }
  }

  setupEvents() {
    /* selectors */


    // COLOR DROPDOWNS
    const dropdowns = document.querySelectorAll('[data-color-dropdown]');
    dropdowns.forEach(dropdown => {
      const toggle = dropdown.querySelector('.color-dropdown-toggle');
      const options = dropdown.querySelector('.color-dropdown-options');
      const items = dropdown.querySelectorAll('.color-dropdown-option');

      const selectedLabel = dropdown.querySelector('.color-dropdown-selected');
      const swatchPreview = dropdown.querySelector('.color-swatch-preview');

      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        dropdown.setAttribute('aria-expanded', String(!isOpen));
      });

      items.forEach(item => {
        item.addEventListener('click', () => {
          const value = item.dataset.value;
          const swatchColor = item.dataset.color;

          selectedLabel.textContent = value;
          if (swatchPreview && swatchColor) swatchPreview.style.backgroundColor = swatchColor;
          items.forEach(i => i.setAttribute('aria-selected', 'false'));
          item.setAttribute('aria-selected', 'true');
          toggle.setAttribute('aria-expanded', 'false');
          dropdown.setAttribute('aria-expanded', 'false');
          this.checkValues()
        });

        item.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            item.click();
          }
        });
      });

      document.addEventListener('click', e => {
        if (!dropdown.contains(e.target)) {
          toggle.setAttribute('aria-expanded', 'false');
          dropdown.setAttribute('aria-expanded', 'false');
        }
      });
    });
    let validateFieldEvent = (field, blurEvent = false) => {

      if (field.classList.contains("error")) {
        if (this.isValidField(field)) {

          field.classList.remove("error")
        } else {

        }
      } else if (blurEvent) {
        if (this.isValidField(field)) {
          field.classList.remove("error")
        } else {
          field.classList.add("error")
        }
      }

    }
    document.querySelectorAll(".supplemental-form-input[required]").forEach(field => field.addEventListener("blur", event => {
      validateFieldEvent(field, true)
    }))
    document.querySelectorAll(".supplemental-form-input[required]").forEach(field => field.addEventListener("keydown", event => {

      validateFieldEvent(field, false)
    }))

    /* set default selections */


    // SHIPPING TYPE SELECTOR (Only handles showing download link)
    const shippingInputs = document.querySelectorAll('input[data-shipping-type]');
    const multiNote = document.getElementById('multi-shipping-note');

    if (!shippingInputs.length || !multiNote) {

    } else {
      shippingInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.checkValues();
          const isMulti = input.checked && input.value === 'Multiple Addresses';
          console.log('Shipping type changed:', input.value, '→ show file?', isMulti);
          multiNote.style.display = isMulti ? 'block' : 'none';
        });
      });
    }
    this.submitButton.addEventListener("click", event => this.finalize())


  }
  hasUploads(type) {
    let fileInput = this.fileField(type);
    if (!fileInput) {
      return false;
    }
    return fileInput.files.length > 0;
  }
  fileField(type) {
    return document.querySelector(`[name="${type}"]`)
  }
  uploadFiles(types) {
    let uploadForm = new FormData();
    uploadForm.append("uuid", this.uuid)
    let uploadCount = 0;
    types.forEach(type => {
      let uploadField = this.fileField(type);
      if (uploadField && uploadField.files.length > 0) {
        uploadForm.append(type, uploadField.files[0]);
        uploadCount++;
      }
    })
    return fetch(
      `${this.config.appUrl}/upload`,
      {
        method: "POST",
        body: uploadForm,
      }
    ).then(response => response.json())
  }
  collectUploads(properties, uploadFields) {
    let uploads = []
    uploadFields.forEach(uploadType => {

      if (this.hasUploads(uploadType)) {
        if (!this.uploadCache[uploadType]) {

          uploads.push(uploadType);
        } else {
          console.error(`skipping upload ${uploadType}: ${properties._gifting[uploadType]}`)
        }
      }
    });

    return uploads;
  }
  finalize() {
    let properties = this.buildProperties();

    if (properties._shipping_type == "multiple") {
      this.processMulti();
      return;
    }
    this.submitButton.disabled = true;
    this.submitButton.classList.remove("inactive")
    this.submitButton.classList.add("processing");

    let hasUploads = false;
    let uploadFields = ["logo_upload", "addresses_upload"];
    let uploads = this.collectUploads(properties, uploadFields)
    if (uploads.length > 0) {
      this.uploadFiles(uploads).then(uploads => {
        if (uploads.error) {
          CnRModal.show("An error has occurred uploading files. Please try again in a little while.")
          this.submitButton.classList.remove("inactive")
          this.submitButton.classList.remove("processing")
          this.submitButton.disabled = false;
          return;
        }
        Object.keys(uploads.urls).forEach(uploaded => {
          properties._gifting[uploaded] = uploads.urls[uploaded].id;
          this.uploadCache[uploaded] = uploads.urls[uploaded].id;
        })
        this.postUpload(properties);
      })
    } else {
      this.postUpload(properties);
    }
  }

  postUpload(properties) {

    if (properties._gifting.shipping_type == "single") {
      this.processCart(properties);
    } else {
      this.processMulti(properties)
    }
  }
  isValidField(field) {
    if (field.dataset.regex) {
      let re = new RegExp(field.dataset.regex);
      if (field.value.match(re) && field.value != "") {
        return true
      } else {
        return false;
      }
    } else {
      switch (field.tagName) {
        case "INPUT":
          if (field.value != "") {
            return true;
          }
          break;
        case "SELECT":
          if (field.options[field.selectIndex].value != "") {
            return true;
          }

      }
    }
    return false;
  }
  processMulti(properties) {

    let proceed = true;
    let payload = properties._gifting;
    payload.quantity = this.quantity()
    payload.productId = this.config.productId;
    Object.entries(this.uploadCache).forEach(kvp => payload[kvp[0]] = kvp[1])

    document.querySelectorAll(".supplemental-form-input").forEach(field => {
      if (!field.hasAttribute("required") && field.value != "") {
        payload[field.name] = field.value
      }
      if (!this.isValidField(field)) {
        field.classList.add("error")
        proceed = false;
      } else {
        field.classList.remove("error")
        payload[field.name] = field.value
      }
    })

    if (proceed) {
      fetch(`${this.config.appUrl}/gifting/cart/${this.uuid}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }
      ).then(response => response.json()).then(result => {
        location.href = `/pages/order-inquiry`
      })

    } else {
      this.submitButton.disabled = false;
      this.submitButton.classList.remove("processing")
    }


  }
  quantity() {
    return parseInt(document.querySelector(".quantity__input").value)
  }
  processCart(properties) {

    properties._gifting = btoa(JSON.stringify(properties._gifting))
    this.addToCart(
      {
        items: [
          {
            id: parseInt(this.config.productId),
            quantity: this.quantity(),
            properties: properties
          }
        ],

      }
    ).then(cart => {
      console.error(cart)
    })
  }

}

class LilacGiftingReview extends CnR {
  constructor(options = {}) {
    super(options)
    this.params = new URLSearchParams(location.search)
    this.uuid = sessionStorage.getItem("giftingUuid")
    if (this.uuid == null) {
      this.cartIsEmpty();
      return;
    }
    this.cartContents = null;
    fetch(`${this.config.appUrl}/gifting/cart/${this.uuid}`).then(response => response.json()).then(json => {
      console.error("return", json)
      this.cartContents = json;
      this.products = this.cartContents.lineItems.map(lineItem => lineItem.productInformation);
      this.render()
      this.setupEvents()
    })
  }
  cartIsEmpty() {
    let root = document.querySelector(".srd-gifting-cart-body");
    document.querySelector(".gifting-submit-item").disabled = true;
    root.innerHTML = `<tr><td colspan="5">Your cart is empty</td></tr>`
  }
  render() {
    let root = document.querySelector(".srd-gifting-cart-body");
    let renderItems = this.cartContents.lineItems;

    if (renderItems.length < 1) {
      this.cartIsEmpty();

      return
    } else {
      document.querySelector(".gifting-submit-item").disabled = false;
    }
    let contents = `
      ${renderItems.map((lineItem, index) =>
      `<tr class="cart-item" id="CartItem-1" data-cart-index=${index}>
        <td class="cart-item__media">                
          <a href="/products/${lineItem.product.handle}?variant=${lineItem.product.productId}" class="cart-item__link" aria-hidden="true" tabindex="-1">
          <div class="cart-item__image-container gradient global-media-settings">
            <img src="${lineItem.product.image}" class="cart-item__image" alt="${lineItem.product.alt}" loading="lazy" width="150" height="113">
          </div>
        </a>
        </td>
        <td class="cart-item__details">
          <a href="/products/${lineItem.product.handle}?variant=${lineItem.productId}" class="cart-item__name h4 break">${lineItem.product.title}</a>
          <div class="product-option">
            $${lineItem.product.price}
          </div>
            <dl>
            ${lineItem.items.map(item => `
              <div class="product-options">
                <dt>${item.title}</dt>
              </div>
            `).join("\n")
      }
          </dl>
        </td>
        <td class="cart-item__totals right medium-hide large-up-hide">
          <div class="cart-item__price-wrapper">
            <span class="price price--end">
              $${lineItem.product.price}
            </span><
          /div>
        </td>
        <td class="cart-item__quantity">
          <quantity-popover>
            <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
              <label class="visually-hidden" for="Quantity-1">Quantity</label>
                <div class="quantity-popover-container">
                <quantity-input class="quantity cart-quantity">
                  <button class="quantity__button" name="minus" type="button">
                    <span class="visually-hidden">
                      Decrease quantity for ${lineItem.product.title}
                    </span>
                    <span class="svg-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"></path></svg>
                    </span>  
                  </button>
                  <input class="quantity__input" data-quantity-variant-id="${lineItem.product.productId}" data-index="${index}" type="number" name="updates[]" value="${lineItem.product.quantity}" data-cart-quantity="${lineItem.product.quantity}" min="0" data-min="1" step="1" aria-label="Quantity for ${lineItem.product.title}" id="Quantity-1" data-index="1">        
                  <button class="quantity__button" name="plus" type="button">
                    <span class="visually-hidden">
                      Increase quantity ${lineItem.product.title}
                    </span>
                    <span class="svg-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path></svg>
                    </span>
                  </button>
                </quantity-input>
              </div>
              <cart-remove-button id="Remove-1" data-index="1">
                
                  <span class="svg-wrapper srd-remove-button" data-index=${index}>
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path></svg>
                  </span>
                </a>
              </cart-remove-button>
            </div>
            <div class="cart-item__error" id="Line-item-error-1" role="alert">
              <small class="cart-item__error-text"></small>
                <span class="svg-wrapper">
                  <svg class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle><path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path><path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path></svg>
                </span>
            </div>
          </quantity-popover>
        </td>
        <td class="cart-item__totals right small-hide">
          <div class="cart-item__price-wrapper">
            <span class="price price--end line-total" data-index="${index}">
              $${parseFloat(lineItem.product.price) * lineItem.quantity}
            </span>
          </div>
        </td>
      </tr>`).join("\n")
      }
    `;
    root.innerHTML = contents;
  }
  isValidField(field) {
    if (field.dataset.regex) {
      let re = new RegExp(field.dataset.regex);
      if (field.value.match(re) && field.value != "") {
        return true
      } else {
        return false;
      }
    } else {
      switch (field.tagName) {
        case "INPUT":
          if (field.value != "") {
            return true;
          }
          break;
        case "SELECT":
          if (field.options[field.selectIndex].value != "") {
            return true;
          }

      }
    }
    return false;
  }
  processForm() {
    let errors = []
    let payload = this.cartContents;
    payload.contact = {}
    payload.uuid = this.uuid;
    document.querySelectorAll(".quantity__input").forEach((quantity, index) => {
      if (payload.lineItems[index]) {
        payload.lineItems[index].quantity = parseInt(quantity.value);
      }
    })
    payload.uuid = this.uuid;
    let formDiv = document.querySelector(".fake-cart-form")

    document.querySelectorAll(".supplemental-form-input").forEach(field => {
      if (!field.hasAttribute("required")) {
        payload.contact[field.name] = field.value;
        return;
      }

      if (!this.isValidField(field)) {
        field.classList.add("error")
        errors.push(field.getAttribute("placeholder"))
      } else {
        field.classList.remove("error")
        payload.contact[field.name] = field.value
      }
    })

    document.querySelectorAll(".quantity__input").forEach((quantity, index) => {
      payload.lineItems[index].quantity = parseInt(quantity.value);
    })

    let errorField = document.querySelector(".fake-cart-form .form-errors");
    console.error(errors)
    if (errors.length > 0) {
      errorField.innerHTML = `<ul>${errors.map(error => `<li>${error}</li>`).join("\n")}</ul>`
      formDiv.classList.add("error")

    } else {
      errorField.innerHTML = ''
      formDiv.classList.remove("error")
      console.error(payload)
      this.submitForm(payload)
    }
  }
  setupEvents() {
    document.querySelector(".gifting-submit-item").addEventListener("click", event => {
      this.processForm()
    })
    document.querySelectorAll(".quantity__input").forEach((quantity, index) => quantity.addEventListener("change", event => {
      let quantityOf = parseInt(quantity.value)
      this.cartContents.lineItems[index].quantity = quantityOf;
      let priceField = document.querySelector(`[data-cart-index="${index}"] .line-total`);
      if (priceField) {
        this.updateCart(this.cartContents).then(cart => {
          priceField.textContent = `$${quantityOf * parseFloat(this.cartContents.lineItems[index].product.price)}`
        })
      }
    }))
    document.querySelectorAll(".srd-remove-button").forEach((remover, index) => remover.addEventListener("click", event => {
      console.error(index)
      this.cartContents.lineItems = this.cartContents.lineItems.filter((item, itemIndex) => {

        return itemIndex != index
      });

      this.updateCart(this.cartContents).then(cart => {
        this.render()
        this.setupEvents()
      })
    }))
  }
  updateCart(payload) {
    return fetch(`${this.config.appUrl}/gifting/cart/${this.uuid}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }).then(response => response.json())
  }
  quantity() {
    return parseInt(document.querySelector(".quantity__input").value)
  }
  submitForm(payload) {
    console.error("submit", payload)
    fetch(`${this.config.appUrl}/gifting/create`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }
    ).then(response => response.json()).then(result => {
      console.error(result)
      if (result.error) {
        alert("An unexpected error has occured.")
      } else {
        let formDiv = document.querySelector(".fake-cart-form");
        formDiv.classList.add("success")
        formDiv.scrollIntoView(true);
        let notificationDiv = document.querySelector(".gifting-create-success p")
        if (notificationDiv) {
          notificationDiv.innerHTML = `
              Your Order Number is {${result.draftOrderId}}
              <br>
              <br>
              Your request has been received and our Gifting Concierge will be in touch shortly to confirm 
              the details and provide shipping totals.`
        }
        sessionStorage.removeItem("giftingUuid")

      }
    })
  }
}

/* Sync cart-icon-bubble when Rebuy adds/modifies cart items */
document.addEventListener('rebuy:cart.change', function () {
  fetch('/?sections=cart-icon-bubble')
    .then(function (res) { return res.json(); })
    .then(function (sections) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble || !sections['cart-icon-bubble']) return;
      var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var inner = parsed.querySelector('.shopify-section');
      if (inner) bubble.innerHTML = inner.innerHTML;
    });
});

/* File Upload Product Block */
document.addEventListener('DOMContentLoaded', function () {
  const sourceInput = document.getElementById('custom-logo-upload');
  const targetInput = document.getElementById('custom-logo-upload-hidden');

  if (!sourceInput || !targetInput) {
    return;
  }

  sourceInput.addEventListener('change', function (event) {
    const files = event.target.files;

    if (files.length > 0) {
      const file = files[0];

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);

      targetInput.files = dataTransfer.files;
    }
  });
});